import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitResponsibleUser = class PitResponsibleUser {
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitResponsibleUser.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitResponsibleUser.prototype, "responsibilityTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitResponsibleUser.prototype, "userId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Boolean)
], PitResponsibleUser.prototype, "isTypeEditable", void 0);
PitResponsibleUser = tslib_1.__decorate([
    jsonObject()
], PitResponsibleUser);
export { PitResponsibleUser };
